import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCredentials, setCredentials } from "../../authSlice";
import toast from "react-hot-toast";
import Select from "react-select";

function AddSale({ onSaleAdded }) {
  const { token } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    zimindarId: "",
    customerId: "",
    item: "",
    weight: "",
    price: "",
    nug: 0,
    bardana: "",
    netPrice: 0,
  });
  const [errors, setErrors] = useState({});
  const [zimidars, setZimidars] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedZimindarId, setSelectedZimindarId] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const dispatch = useDispatch();
  const [tokenExpired, setTokenExpired] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  useEffect(() => {
    const fetchZimidars = async () => {
      setLoading(true);
      setApiError(null);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/getZimindarofTodayorByDate`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 401) {
          setTokenExpired(true);
          return;
        }

        if (response.ok) {
          const newAccessToken = response.headers.get("Authorization");
          if (newAccessToken) {
            dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
          }
          const data = await response.json();
          setZimidars(data.payments || []);
        } else {
          throw new Error("Failed to fetch zimidars.");
        }
      } catch (err) {
        setApiError(err.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchCustomers = async () => {
      setLoading(true);
      setApiError(null);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/getAllCustomers`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 401) {
          setTokenExpired(true);
          return;
        }

        if (response.ok) {
          const newAccessToken = response.headers.get("Authorization");
          if (newAccessToken) {
            dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
          }
          const data = await response.json();
          setCustomers(data.customers || []);
        } else {
          throw new Error("Failed to fetch customers.");
        }
      } catch (err) {
        setApiError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (tokenExpired) {
      dispatch(clearCredentials());
      return;
    }

    if (!token || token === "null") {
      dispatch(setCredentials({ token: null, username: null }));
    } else {
      fetchZimidars();
      fetchCustomers();
    }
  }, [dispatch, token, tokenExpired]);

  const handleZimindarChange = (e) => {
    // getting payment id
    const paymentId = e.target.value;
    setErrors((prevErrors) => ({ ...prevErrors, ["zimindarId"]: "" }));
    // getting payment from payment
    const selectedPayment = zimidars.find((z) => z._id === paymentId);
    setSelectedZimindarId(selectedPayment._id);
    setFormData((prevFormData) => ({
      ...prevFormData,
      zimindarId: selectedPayment.zimindarId,
    }));

    if (selectedPayment) {
      setItems(selectedPayment.itemsDescription);
    } else {
      setItems([]); // Reset items if no zimindar found
    }
  };

  useEffect(() => {
    if (items.length === 1 && selectedZimindarId) {
      setErrors((prevErrors) => ({ ...prevErrors, ["item"]: "" }));
      setFormData((prev) => ({
        ...prev,
        item: items[0],
      }));
    }
  }, [items, selectedZimindarId]);

  const validateForm = () => {
    let formErrors = {};

    if (!formData.zimindarId) formErrors.zimindarId = "Zimindar is required";
    if (!formData.customerId) formErrors.customer = "customer is required";
    if (!formData.item) formErrors.item = "item is required";
    if (!formData.weight) formErrors.weight = "weight is required";
    if (!formData.price) formErrors.price = "price is required";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);

    const url =
      formData.customerId < 0
        ? `${process.env.REACT_APP_API_URL}/sales/createCashSale`
        : `${process.env.REACT_APP_API_URL}/sales/create`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 401) {
        dispatch(clearCredentials());
        return;
      }

      if (response.ok) {
        const newAccessToken = response.headers.get("Authorization");
        if (newAccessToken) {
          dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
        }
        const data = await response.json();
        if (data.status === 201 || data.status === 200) {
          toast.success("Sale added successfully", {
            style: {
              border: "1px solid #021F7E",
              padding: "16px",
              color: "#0573E3",
            },
            iconTheme: {
              primary: "#021F7E",
              secondary: "#fff",
            },
            duration: 6000,
          });
          // setSelectedZimindarId("");
          setFormData((prev) => ({
            ...prev,
            customerId: "",
            weight: "",
            price: "",
            nug: 0,
            bardana: "",
            netPrice: 0,
          }));
          onSaleAdded();
        } else {
          console.error("Error:", data.message);
        }
      } else {
        const data = await response.json();
        toast.error(data.message, {
          style: {
            border: "1px solid #FE0000",
            padding: "16px",
            color: "#FE0000",
          },
          iconTheme: {
            primary: "#FE0000",
            secondary: "#FE000099",
          },
          duration: 6000,
        });
        console.error("Failed to add sale: ", data.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  if (apiError) return <div>Error: {apiError}</div>;

  const customerOptions = [
    ...customers.map((customer) => ({
      value: customer._id,
      label: customer.name,
    })),
    { value: -1, label: "Cash Jassi" }, // Special "Cash" option
    { value: -2, label: "Cash Suraj" }
  ];

  // Handle select change
  const handleCustomerChange = (selectedOption) => {
    setErrors((prevErrors) => ({ ...prevErrors, ["customer"]: "" }));
    setFormData((prevData) => ({
      ...prevData,
      customerId: selectedOption ? selectedOption.value : "",
    }));
  };

  return (
    <>
      <div className="whiteBgDiv UserManagementPadding">
        <div className="mainHeading">Sales</div>
        <div className="formHeading UserManagementpage">Stock Sale</div>
        <div className="addSaleGrid">
          <div className="formInputLabelBox">
            <label>Zimindar</label>
            <select
              name="zimindarId"
              className="form-select"
              value={selectedZimindarId}
              onChange={handleZimindarChange}
            >
              <option value="" disabled>
                Select Zimindar
              </option>
              {zimidars.map((zimidar) => (
                <option key={zimidar._id} value={zimidar._id}>
                  {zimidar.zimindarId.name}
                </option>
              ))}
            </select>
            {errors.zimindarId && (
              <span className="errorClass">{errors.zimindarId}</span>
            )}
          </div>
          <div className="formInputLabelBox">
            <label>Customer</label>
            <Select
              name="customerId"
              options={customerOptions}
              value={
                customerOptions.find(
                  (opt) => opt.value === formData.customerId
                ) || null
              }
              onChange={handleCustomerChange}
              placeholder="Select Customer"
              isClearable
              className="formInputBoxSelectContainer"
              classNamePrefix="formInputBoxSelect"
            />
            {/* <select
 name="customerId"
 className="form-select"
 value={formData.customerId}
 onChange={handleInputChange}
 >
 <option value="">Select Customer</option>
 {customers.map((customer) => (
 <option key={customer._id} value={customer._id}>
 {customer.name}
 </option>
 ))}
 <option value={-1}>Cash</option>
 </select> */}
            {errors.customer && (
              <span className="errorClass">{errors.customer}</span>
            )}
          </div>
          <div className="formInputLabelBox">
            <label>Item</label>
            <select
              name="item"
              className="form-select"
              value={formData.item}
              onChange={handleInputChange}
            >
              {items.length !== 1 ? (
                <>
                  <option value="">Select Item</option>
                  {items.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </>
              ) : (
                // If only one item, still render it as the only option
                <option value={items[0]}>{items[0]}</option>
              )}
            </select>
            {errors.item && <span className="errorClass">{errors.item}</span>}
          </div>
          <div className="formInputLabelBox">
            <label>Weight</label>
            <input
              name="weight"
              type="text"
              placeholder="Enter here"
              value={formData.weight}
              onChange={(e) => {
                const value = e.target.value;
                // if (/^\d*$/.test(value)) handleInputChange(e);
                if (/^\d*\.?\d*$/.test(value)) handleInputChange(e);
              }}
            />
            {errors.weight && (
              <span className="errorClass">{errors.weight}</span>
            )}
          </div>
          <div className="formInputLabelBox">
            <label>Price</label>
            <input
              name="price"
              type="text"
              placeholder="Enter here"
              value={formData.price}
              onChange={(e) => {
                const value = e.target.value;
                // if (/^\d*$/.test(value)) handleInputChange(e);
                if (/^\d*\.?\d*$/.test(value)) handleInputChange(e);
              }}
            />
            {errors.price && <span className="errorClass">{errors.price}</span>}
          </div>
          <div className="formInputLabelBox">
            <label>Nug</label>
            <input
              name="nug"
              type="text"
              placeholder="Enter here"
              value={formData.nug === 0 ? "" : formData.nug}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) handleInputChange(e);
              }}
            />
            {errors.nug && <span className="errorClass">{errors.nug}</span>}
          </div>
          <div className="formInputLabelBox">
            <label>Bardana</label>
            <select
              name="bardana"
              className="form-select"
              value={formData.bardana}
              onChange={handleInputChange}
            >
              <option value="">Select Bardana</option>
              {/* {allZimidars.map((zimidar) => (
 <option key={zimidar._id} value={zimidar._id}>
 {zimidar.name}
 </option>
 ))} */}
            </select>
            {errors.bardana && (
              <span className="errorClass">{errors.bardana}</span>
            )}
          </div>
        </div>

        <div className="d-flex align-items-center ">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={formData.netPrice}
              value={formData.netPrice}
              id="NetPrice"
              onChange={(e) => {
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  netPrice: e.target.checked ? 1 : 0,
                }));
              }}
            />
          </div>
          <div className="formInputLabelBox">
            <label htmlFor="NetPrice">Net Price</label>
          </div>
        </div>

        <div className="UserManagementBtnFlexDiv">
          {!loading ? (
            <button className="colorBtn" onClick={handleSubmit}>
              Add Sale
            </button>
          ) : (
            <button className="colorBtn">Loading ...</button>
          )}
        </div>
      </div>
    </>
  );
}

export default AddSale;
